module.exports = __webpack_public_path__ + "img/date_b.d85045c2.svg";